import { useDeepCompareEffect } from "@react-hookz/web";
import { useCallback, useState } from "react";

import type { Props } from "~/components/advertisement/ad-slots/ad-slot";

export const useAdSlotWithRefresh = (props: Exclude<Props, "manualRefreshCount">) => {
  const [manualRefreshCount, setManualRefreshCount] = useState(0);

  useDeepCompareEffect(() => {
    setManualRefreshCount(0);
  }, [props]);

  return {
    props: {
      ...props,
      manualRefreshCount,
    },
    refresh: useCallback(() => setManualRefreshCount(v => v + 1), [setManualRefreshCount]),
  };
};
